import React, { useState, useRef, useEffect } from "react";
import { Home } from "lucide-react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { apiUrl } from "../config/Config";
import { useTranslation } from "react-i18next";
import Editor from "../components/Editor";
import bannerImg from "../assets/images/createstorynewbanner.webp";
import Spinner from "react-activity/dist/Spinner";
import Swal from 'sweetalert2';
import Cropper from "react-easy-crop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
import SpeechRecognition, {
  useSpeechRecognition
} from "react-speech-recognition";

const CreateStory = () => {

  const FIXED_ASPECT = 638 / 380;

  const customerdata = useSelector((store) => store.userReducer.customerdata);
  // console.log('customerdata >>', customerdata);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  // dispatch({ type: "customerdata", payload: {} });
  const navigate = useNavigate();
  const [format, setFormat] = useState("write");
  const [storyText, setStoryText] = useState("");
  const [title, setTitle] = useState("");
  const [language, setLanguage] = useState("en");
  const [photos, setPhotos] = useState([]);
  const [audioUrl, setAudioUrl] = useState(null);
  const [recording, setRecording] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [selecteddiety, setselecteddiety] = useState("");
  const [selectedfestival, setselectedfestival] = useState("");
  const [selectedplace, setselectedplace] = useState("");
  const [editorLoaded, setEditorLoaded] = useState(true);
  const [islistening, setisListening] = useState(false);
  const [text, setText] = useState("");

  const [showloading, setshowloading] = useState(false);

  const [hideName, setHideName] = useState(false);

  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const fileInputRef = useRef(null);
  const recognitionRef = useRef(null);

  const [errortitlemessage, seterrortitlemessage] = useState("");
  const [errorstorytext, seterrorstorytext] = useState("");
  const [errorstoryaudio, seterrorstoryaudio] = useState("");



  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      setCropModalOpen(true);
    }

    // Reset input
    e.target.value = "";
  };


  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const createCroppedImage = async () => {
    const image = new Image();
    image.src = selectedImage;

    await new Promise((resolve) => {
      image.onload = resolve;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // FIXED OUTPUT SIZE
    canvas.width = 638;
    canvas.height = 380;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      638,
      380
    );

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", 0.95)
    );

    const file = new File([blob], "story-image.jpg", {
      type: "image/jpeg",
    });

    setPhotos([file]);

    // ✅ Reset file input (important)
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setCropModalOpen(false);
  };











  const handleLanguageChange = (e) => {
    i18n.changeLanguage(e.target.value);
    setLanguage(e.target.value);
  };

  const toggleTranscription = () => {
    if (isTranscribing) recognitionRef.current.stop();
    else recognitionRef.current.start();
    setIsTranscribing(!isTranscribing);
  };

  // const startspeechtotext = () => {
  //   var prevtext = storyText;
  //   const SpeechRecognition =
  //     window.SpeechRecognition || window.webkitSpeechRecognition;

  //   if (!SpeechRecognition) {
  //     alert("Speech Recognition not supported in this browser!");
  //     return;
  //   }

  //   const recognition = new SpeechRecognition();
  //   recognition.continuous = true;
  //   recognition.interimResults = true;
  //   recognition.lang = "en-IN"; // change language if needed

  //   recognition.onresult = (event) => {
  //     const transcript = Array.from(event.results)
  //       .map((result) => result[0].transcript)
  //       .join("");
  //     var nexttext = prevtext + " " + transcript;
  //     setStoryText(nexttext);
  //   };

  //   recognition.onerror = (event) => {
  //     console.error("Speech recognition error:", event.error);
  //     setisListening(false);
  //   };

  //   recognition.onend = () => {
  //     console.log("Speech recognition stopped.");
  //     setisListening(false);
  //   };

  //   recognition.start();
  //   recognitionRef.current = recognition;
  //   setisListening(true);
  // }
  const baseTextRef = useRef("");
  const accumulatedTranscriptRef = useRef("");
  const {transcript,listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();

  const startspeechtotext = () => {
    // baseTextRef.current = storyText; // store existing text    
    // resetTranscript(); // clear previous transcript

    // SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
    // setisListening(true);


    if (listening) return; // prevent multiple starts

    baseTextRef.current = storyText;

    resetTranscript();

    SpeechRecognition.startListening({
      continuous: true,
      language: "en-IN",
    });
    setisListening(true);
  };
  

  const stoospeechtotext = () => {
    // console.log('stopppp >>>>>', recognitionRef.current);
    // recognitionRef.current.stop();
    SpeechRecognition.stopListening();
    setisListening(false);
  };

  console.log('text >>', text);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      mediaRecorderRef.current.ondataavailable = (e) =>
        chunksRef.current.push(e.data);
      mediaRecorderRef.current.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "audio/webm" });
        setAudioUrl(URL.createObjectURL(blob));
        chunksRef.current = [];
      };
      mediaRecorderRef.current.start();
      setRecording(true);
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };



  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      setCropModalOpen(true);
    }
  };

  const handleSubmit = async (e) => {
    console.log('photos >>', photos);
    // if (title) {

    // } else {
    //   Swal.fire({
    //     title: "",
    //     text: "Mandatory fields cannot be empty",
    //     icon: "error",
    //     customClass: {
    //       icon: "custom-swal-icon", // Apply the custom class
    //     },
    //     width: "350px",
    //     confirmButtonText: "Ok",
    //     confirmButtonColor: "rgb(59, 151, 196)",
    //     customClass: {
    //       popup: "small-icon-alert",
    //     },
    //   });
    //   return;
    // }
    var istitleerror = false;
    var isstorytexterror = false;
    var isstoryaudioerror = false;

    if(title) {
      seterrortitlemessage("");
      istitleerror = false;
    } else {
      seterrortitlemessage("Title of the story cannot be empty.");
      istitleerror = true;
    }

    if(format === "write") {
      seterrorstoryaudio("");
      isstoryaudioerror = false;
      if(storyText) {
        seterrorstorytext("")
        isstorytexterror = false;
      } else {
        seterrorstorytext("Story text is mandatory.")
        isstorytexterror = true;
      }
    } else {
      seterrorstorytext("")
      isstorytexterror = false;
      if(audioUrl) {
        seterrorstoryaudio("")
        isstoryaudioerror = false;
      } else {
        seterrorstoryaudio("Audio story is mandatory.")
        isstoryaudioerror = true;
      }
    }

    if(!istitleerror && !isstorytexterror && !isstoryaudioerror) {
    } else {
      return;
    }

    var data = {
      storytype: format === "write" ? "textbased" : "audiobased",
      language: language,
      title: title,
      storyText: storyText,
      photos: photos,
      deity: selecteddiety,
      festival: selectedfestival,
      place: selectedplace,
      audio: audioUrl,
      hide_author: hideName
    }
    console.log('data >>>', data);
    // return;
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: "Bearer " + customerdata?.token,
      }
    }
    const formData = new FormData();
    formData.append("type", "adults");
    formData.append("storytype", format === "write" ? "textbased" : "audiobased");
    formData.append("language", language);
    formData.append("title", title);
    formData.append("storyText", storyText);
    formData.append("deity", selecteddiety);
    formData.append("festival", selectedfestival);
    formData.append("place", selectedplace);
    formData.append("hide_author", hideName == true ? "true" : false);
    photos.forEach(img => {
      formData.append("photos[]", img);
    });
    if (audioUrl) {
      const blob = await fetch(audioUrl).then(r => r.blob());
      // Wrap into a File (optional but cleaner)
      const file = new File([blob], "recording.webm", { type: blob.type });
      console.log('file >>', file);
      formData.append("audio", file);
    }

    setshowloading(true);
    let resp = await axios
      .post(apiUrl + "createstory", formData, headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        setshowloading(false);
        if (res.data.status == "success") {
          navigate('/allstory');
        } else {
          alert(res.data.message || "Unable to submit story");
        }
      })
      .catch((err) => {
        // setshowloding(false);
        alert(err.response?.data?.message || err.message);
        setshowloading(false);
      });
    setshowloading(false);



    // alert("🌸 Story submitted successfully!");
  };

  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = true;
      recognitionRef.current.interimResults = true;
      recognitionRef.current.lang = language;
      recognitionRef.current.onresult = (event) => {
        let finalTranscript = "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcript + " ";
          }
        }
        // setStoryText((prev) => prev + finalTranscript);
      };
      recognitionRef.current.onend = () => setIsTranscribing(false);
    }
  }, [language]);

  useEffect(() => {
    if (customerdata && Object.keys(customerdata).length > 0) {
      if (customerdata?.payment_status !== "completed") {
        alert('Please complete payment before writing a story');
        navigate('/');
      } else {

      }

    } else {
      navigate('/login');
    }
  }, [customerdata, navigate])

  // useEffect(() => {
  //   console.log('listening >>', listening);
  // }, [listening])

  useEffect(() => {
    if (listening) {
      setStoryText(baseTextRef.current + transcript);
    }
  }, [transcript, listening]);



  return (
    <div>
      <section className="home-main-sec ">
        <img src={bannerImg} className="home-main-sec-bg" alt="Banner" />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">
          <h1 className="loop-title">Create Your Spiritual Story</h1>
        </div>
      </section>

      <div className="create-story-container">
        <h2 className="create-story-header">
          🕉 {t("createyourspritualstory")}
        </h2>

        {/* Language & Title */}
        <div className="create-story-group">
          {/* <label>Language</label> */}
          <label>{t("language")}</label>
          <select
            value={language}
            onChange={handleLanguageChange}
            className="create-story-dropdown  langauge-label"
          >
            <option value="en">English</option>
            <option value="hi">हिंदी</option>
            {/* <option value="bn">বাংলা</option>
            <option value="gu">ગુજરાતી</option>
            <option value="ml">മലയാളം</option>
            <option value="mr">मराठी</option>
            <option value="pa">ਪੰਜਾਬੀ</option>
            <option value="kn">ಕನ್ನಡ</option>
            <option value="ta">தமிழ்</option>
            <option value="te">తెలుగు</option> */}
          </select>
        </div>
        <div className="create-story-form">
          {/* Format */}
          <div className="create-story-group">
            <label>{t("chooseformat")}</label>
            <div className="create-story-options  create-story-options-chhose-formet-btn ">
              <p
                type="button"
                className={`create-story-option-btn ${
                  format === "write" ? "active" : ""
                }`}
                onClick={() => setFormat("write")}
              >
                ✍ {t("writemystory")}
              </p>
              <p
                type="button"
                className={`create-story-option-btn ${
                  format === "record" ? "active" : ""
                }`}
                onClick={() => setFormat("record")}
              >
                🎤 {t("recordmystory")}
              </p>
            </div>
          </div>
          <div className="create-story-group hide-name-section">
            <label className="hide-name-label">
              {t("hidemyname")}

              <input
                type="checkbox"
                checked={hideName}
                className="hide-name-label"
                onChange={(e) => setHideName(e.target.checked)}
              />
            </label>
          </div>

          <div className="create-story-group">
            <label>{t("title")} *</label>
            <input
              type="text"
              placeholder={t("enterstorytitle") + "..."}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="create-story-input"
              required
            />
            {errortitlemessage ? (
              <p className="register-error-message createstory-error-message">
                {errortitlemessage}
              </p>
            ) : null}
          </div>

          {/* Write Story */}
          {format === "write" && (
            <>
              <div className="create-story-group">
                <label>{t("writestory")} *</label>
                {/* <textarea
                  placeholder={t("startwritingorusemic") + "..."}
                  value={storyText}
                  onChange={(e) => setStoryText(e.target.value)}
                  rows="8"
                  className="create-story-textarea"
                /> */}
                <Editor
                  storyEditor
                  value={storyText}
                  onChange={(data) => {
                    setStoryText(data);
                  }}
                  editorLoaded={editorLoaded}
                />
                {errorstorytext ? (
                  <p className="register-error-message createstory-error-message">
                    {errorstorytext}
                  </p>
                ) : null}
                {listening ? (
                  <button
                    type="button"
                    className={`create-story-mic-btn active`}
                    onClick={stoospeechtotext}
                  >
                    {"🛑" + t("stopspeaking")}
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`create-story-mic-btn `}
                    // onClick={toggleTranscription}
                    onClick={startspeechtotext}
                  >
                    {"🎙" + t("Voice To Text")}
                  </button>
                )}
              </div>
            </>
          )}

          {/* Record Story */}
          {format === "record" && (
            <div className="create-story-group">
              <label>{t("recordaudio")} *</label>
              <div className="create-story-audio-controls">
                {!recording ? (
                  <button
                    type="button"
                    onClick={startRecording}
                    className="create-story-record-btn"
                  >
                    🎙 {t("startspeaking")}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={stopRecording}
                    className="create-story-stop-btn"
                  >
                    ⏹ {t("stopspeaking")}
                  </button>
                )}
                {/* {audioUrl && <audio controls src={audioUrl}></audio>} */}
                {audioUrl ? (
                  <div className="d-flex audiourldiv">
                    <audio controls src={audioUrl}></audio>
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="removevoicerecordicon"
                      onClick={() => {
                        setAudioUrl(null);
                      }}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
              {errorstoryaudio ? (
                  <p className="register-error-message createstory-error-message">
                    {errorstoryaudio}
                  </p>
                ) : null}
            </div>
          )}

          {/* Photo Upload */}
          <div className="create-story-group">
            <label>{t("uploadphotos")} </label>
            <div
              className="create-story-drop-zone"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
            >
              <span className="create-story-upload-icon">📷</span>
              <p>{t("draganddrop")}</p>
              <input
                type="file"
                // multiple
                accept="image/*"
                onChange={handlePhotoUpload}
                ref={fileInputRef}
                style={{ display: "none" }}
              />
            </div>
            <div className="create-story-photo-preview">
              {photos.map((file, index) => (
                <div key={index} className="create-story-photo-item">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`preview-${index}`}
                    className="create-story-photo"
                  />
                  <button
                    type="button"
                    className="create-story-photo-delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      const updated = photos.filter((_, i) => i !== index);
                      setPhotos(updated);
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Spiritual Tags */}
          <div className="create-story-group">
            <label className="create-story-tag-header">
              🕉 {t("tagyourstory")}
            </label>

            <div className="create-story-tag-row">
              {/* Deity input field */}
              <div className="create-story-tag-field">
                <input
                  type="text"
                  className="create-story-dropdown"
                  placeholder={t("Deity")}
                  value={selecteddiety}
                  onChange={(t) => setselecteddiety(t.target.value)}
                />
              </div>

              {/* Festival dropdown removed */}

              {/* Place input field */}
              <div className="create-story-tag-field">
                <input
                  type="text"
                  className="create-story-dropdown"
                  placeholder={t("Place")}
                  value={selectedplace}
                  onChange={(t) => setselectedplace(t.target.value)}
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="create-story-submit-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            {showloading ? (
              <Spinner color="#fff" size={16} className="pagespinner" />
            ) : (
              <>🌸 {t("submitstory")}</>
            )}
          </button>
        </div>
      </div>

      {cropModalOpen && (
        <div className="crop-overlay">
          <div className="crop-modal">
            <div className="crop-header">
              <h3>Crop Image</h3>
              <button onClick={() => setCropModalOpen(false)}>✕</button>
            </div>

            <div className="cropper-container">
              <Cropper
                image={selectedImage}
                crop={crop}
                zoom={zoom}
                aspect={FIXED_ASPECT}
                objectFit="cover"
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>

            <div className="crop-controls">
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
              />

              <div className="crop-action-buttons">
                <button
                  className="cancel-btn"
                  onClick={() => setCropModalOpen(false)}
                >
                  Cancel
                </button>
                <button className="apply-btn" onClick={createCroppedImage}>
                  Apply Crop
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateStory;
